<template>
  <div>
    <c-card class="cardClassDetailForm" title="메일 발송">
      <template v-slot:card-button>
        <q-btn-group outline>
          <c-btn
            v-if="editable"
            :isSubmit="isSend"
            :url="sendMailUrl"
            :param="sendPayload"
            mappingType="POST"
            label="메일 발송"
            icon="mail"
            @beforeAction="sendMail"
            @btnCallback="sendMailCallback"
          />
        </q-btn-group>
      </template>
      <template v-slot:card-detail>
        <!-- 좌측: 메일 발송 대상(담당자) -->
        <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
          <c-table
            ref="userTable"
            title="메일 발송 대상 목록"
            :columns="userColumns"
            :data="users"
            :gridHeight="gridHeight"
            :columnSetting="false"
            :filtering="false"
            :usePaging="false"
            :isFullScreen="false"
            :editable="editable"
            selection="multiple"
            rowKey="userId"
          >
            <template v-slot:table-button>
              <q-btn-group outline v-if="editable">
                <c-btn label="추가" icon="add" @btnClicked="addUser" />
                <c-btn label="제외" icon="remove" @btnClicked="excludeUsers" />
              </q-btn-group>
            </template>
          </c-table>
        </div>
        <!-- 우측: 선택한 규제 변경 목록(확인용) -->
        <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8">
          <c-table
            title="규제 변경 목록"
            :columns="historyColumns"
            :data="histories"
            :gridHeight="gridHeight"
            :usePaging="false"
            :isFullScreen="false"
          />
        </div>
      </template>
    </c-card>
    <c-dialog :param="addPopupOptions"></c-dialog>
  </div>
</template>

<script>
import transactionConfig from '@/js/transactionConfig';

export default {
  name: 'chemUpdateHistoryDetail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        // 목록에서 선택한 규제 변경 상세
        histories: [],
        lawName: '',
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: 'auto',
    },
  },
  data() {
    return {
      editable: true,
      isSend: false,
      sendMailUrl: '',
      sendPayload: {},
      // 선택 변경 목록(확인용)
      histories: [],
      // 메일 발송 대상 / 제외 대상
      users: [],
      deletedUsers: [],
      addPopupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
      // 메일 발송 대상 목록 컬럼
      userColumns: [
        {
          name: 'deptName',
          field: 'deptName',
          label: '부서',
          align: 'center',
          style: 'width:120px',
          sortable: true,
        },
        {
          name: 'userName',
          field: 'userName',
          label: '담당자',
          align: 'center',
          style: 'width:120px',
          sortable: true,
        },
        {
          name: 'email',
          field: 'email',
          label: '이메일',
          align: 'left',
          style: 'width:200px',
          sortable: true,
        },
      ],
      // 선택 변경 목록 컬럼(목록 화면과 동일)
      historyColumns: [
        {
          name: 'chemNmKr',
          field: 'chemNmKr',
          label: '화학물질명(국문)',
          align: 'left',
          style: 'width:160px',
          sortable: true,
        },
        {
          name: 'chemNmEn',
          field: 'chemNmEn',
          label: '화학물질명(영문)',
          align: 'left',
          style: 'width:160px',
          sortable: true,
        },
        {
          name: 'casNo',
          field: 'casNo',
          label: 'CAS No.',
          align: 'center',
          style: 'width:100px',
          sortable: true,
        },
        {
          name: 'regulationBillName',
          field: 'regulationBillName',
          label: '법규',
          align: 'center',
          style: 'width:120px',
          sortable: true,
        },
        {
          name: 'regulatedItemName',
          field: 'regulatedItemName',
          label: '규제항목',
          align: 'center',
          style: 'width:120px',
          sortable: true,
        },
        {
          name: 'flagName',
          field: 'flagName',
          label: '변경유형',
          align: 'center',
          style: 'width:70px',
          sortable: true,
        },
        {
          name: 'changeContents',
          field: 'changeContents',
          label: '변경내용',
          align: 'left',
          style: 'width:220px',
          type: 'html',
          sortable: false,
        },
        {
          name: 'regDt',
          field: 'regDt',
          label: '변경일시',
          align: 'center',
          style: 'width:140px',
          sortable: true,
        },
        {
          name: 'notiDt',
          field: 'notiDt',
          label: '고시일자',
          align: 'center',
          style: 'width:100px',
          sortable: true,
        },
      ],
    };
  },
  computed: {
    gridHeight() {
      return '780px';
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      this.sendMailUrl = transactionConfig.chm.regul.updateHistory.sendMail.url;
      // 목록에서 선택한 변경 내역 표시
      this.histories = this.makeDisplayRows(this.popupParam.histories || []);
      this.users = [];
      this.deletedUsers = [];
      if (
        this.popupParam.histories.some((row) => row.regulationBillCd === 'D140') &&
        !this.historyColumns.some((column) => column.name === 'dangerItemName')
      ) {
        this.historyColumns.splice(5, 0, {
          name: 'dangerItemName',
          field: 'dangerItemName',
          label: '위안법 세부분류',
          align: 'left',
          style: 'width:160px',
          sortable: true,
        });
      }
    },
    /**
     * 변경내역 표시용 행 가공
     */
    makeDisplayRows(list) {
      return list.map((row, index) => Object.assign({}, row, {
        mdmMaterialRegulatoryInfoHistoryDetailId:
          row.mdmMaterialRegulatoryInfoHistoryDetailId ||
          `${row.regulatedItemCd}-${row.mdmChemId}-${index}`,
        flagName: row.flagName || (row.flag === 'I' ? '신규' : row.flag === 'D' ? '삭제' : '변경'),
        changeContents: row.changeContents || '',
      }));
    },
    /**
     * 메일 발송 대상 추가 팝업
     */
    addUser() {
      this.addPopupOptions.title = '사용자 검색';
      this.addPopupOptions.param = {
        type: 'multiple',
      };
      this.addPopupOptions.target = () => import(`${'@/pages/common/user/userPop.vue'}`);
      this.addPopupOptions.width = '60%';
      this.addPopupOptions.visible = true;
      this.addPopupOptions.closeCallback = this.closeUserPopup;
    },
    /**
     * 담당자 추가 팝업 닫기 및 목록 반영
     */
    closeUserPopup(_data) {
      this.addPopupOptions.target = null;
      this.addPopupOptions.visible = false;
      if (!_data || _data.length === 0) return;

      const existIds = new Set(this.users.map((row) => String(row.userId)));
      const addRows = [];
      _data.forEach((item) => {
        const userId = String(item.userId || '');
        if (!userId || existIds.has(userId)) return;

        // 제외 목록에 있던 담당자면 복원
        const deletedIdx = this.deletedUsers.findIndex((row) => String(row.userId) === userId);
        if (deletedIdx > -1) {
          const restored = this.deletedUsers[deletedIdx];
          this.deletedUsers.splice(deletedIdx, 1);
          addRows.push(restored);
          existIds.add(userId);
          return;
        }

        addRows.push({
          userId,
          userName: item.userName || '',
          deptName: item.deptName || '',
          email: item.email || '',
          sendDt: '',
          content: '',
          sendFlag: '',
          editFlag: 'C',
          regUserId: this.$store.getters.user.userId,
        });
        existIds.add(userId);
      });
      if (addRows.length === 0) return;

      this.users = [...this.users, ...addRows];
    },
    /**
     * 선택 담당자 제외
     */
    excludeUsers() {
      const selected = this.$refs.userTable ? this.$refs.userTable.selected : [];
      if (!selected || selected.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내',
          message: '제외할 담당자를 선택하세요.',
          type: 'warning',
        });
        return;
      }

      const excludeIds = new Set(selected.map((row) => String(row.userId)));
      const removed = this.users.filter((row) => excludeIds.has(String(row.userId)));
      this.users = this.users.filter((row) => !excludeIds.has(String(row.userId)));

      // 신규(C)는 DB에 없으므로 삭제 목록에 넣지 않음
      const deletedIds = new Set(this.deletedUsers.map((row) => String(row.userId)));
      removed.forEach((row) => {
        if (row.editFlag === 'C') return;
        const id = String(row.userId);
        if (!deletedIds.has(id)) this.deletedUsers.push(row);
      });

      this.$refs.userTable.selected = [];
    },
    /**
     * 메일 발송
     */
    sendMail() {
      if (!this.users || this.users.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내',
          message: '메일 발송 대상을 추가하세요.',
          type: 'warning',
        });
        return;
      }
      if (!this.histories || this.histories.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내',
          message: '발송할 변경 목록이 없습니다.',
          type: 'warning',
        });
        return;
      }

      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '메일을 발송하시겠습니까?',
        type: 'info',
        confirmCallback: () => {
          this.sendPayload = {
            users: this.users,
            histories: this.histories,
            content: '',
            regUserId: this.$store.getters.user.userId,
            chgUserId: this.$store.getters.user.userId,
          };
          this.isSend = !this.isSend;
        },
        cancelCallback: () => {},
      });
    },
    /**
     * 메일 발송 콜백
     */
    sendMailCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('closePopup', { sent: true });
    },
  },
};
</script>
